import { render } from "./hierarchy.vue?vue&type=template&id=508e2ae2&scoped=true"
import script from "./hierarchy.vue?vue&type=script&lang=js"
export * from "./hierarchy.vue?vue&type=script&lang=js"

import "./hierarchy.vue?vue&type=style&index=0&id=508e2ae2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-508e2ae2"]])

export default __exports__